import React from "react";
import * as Scrivito from "scrivito";
import NiceModal from "@ebay/nice-modal-react";
import cx from "classnames";
import { Dropdown, SingleProductDownloadModal } from "components";
import { useTranslate } from "hooks";
import { NodeKinds } from "interfaces/enums";
import { Icon } from "../Icon/Icon";

import styles from "./SummaryListItem.module.scss";

export const ConfigurationItem = Scrivito.connect(({ conf, style = {} }) => {
  const translate = useTranslate();
  const openDownloadModal = (productName, confOrderCode = []) => {
    NiceModal.show(SingleProductDownloadModal, {
      modalSubtitle: productName,
      modalType: "Product",
      orderCode: confOrderCode,
      presentation: conf.presentation,
    });
  };

  return (
    <div
      className={cx(
        "d-flex justify-content-between align-items-center border-bottom ms-5",
        styles.item,
      )}
      style={style}
    >
      <div className="d-flex flex-column ps-2_5 mw-100">
        <div className="fw-bolder fs-mdoverflow-hidden text-truncate">
          {conf.productName}
        </div>
        <div className="text-gray-400 overflow-hidden text-truncate">
          <span>
            {translate("PRESENTATION_ORDER_CODE")}: {conf.presentation}
          </span>{" "}
          |{" "}
          <span>
            {translate("QUANTITY")}: {conf.quantity}
          </span>
        </div>
      </div>
      {conf.presentation &&
        conf.kind !== NodeKinds.TROX_NETCOM_PRODUCT &&
        conf.kind !== NodeKinds.TROX_NETCOM_NOTE &&
        conf.kind !== NodeKinds.TROX_NETCOM_GENERIC_PRODUCT &&
        conf.kind !== NodeKinds.CUSTOM_PRODUCT && (
          <Dropdown
            btnChildren={
              <Icon
                prefix="trox"
                iconName="ellipsis-vertical-regular"
                className="icon-20"
                data-testid="project-product-actions-icon"
              />
            }
            btnId="project_product_actions_icon"
            options={[
              {
                id: "download",
                title: translate("DOWNLOAD"),
                onClick: () =>
                  openDownloadModal(conf.productName, conf.orderCode),
              },
            ]}
          />
        )}
    </div>
  );
});
